export interface OAuth2Tokens {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
  refreshedAt?: number;
  deviceId?: string;
}

export type ApiKey = {
  apiSecret: string;
  passphrase?: string;
  storage: StorageType;
} & PublicApiKey;

export type AuthProvider = "privy" | "ethermail" | "ton" | "local";

export type PublicApiKey = {
  apiPublic: string;
  uid?: string; // Only for Bitmart (name of the api key)
};

export type ExchangeCredentials = {
  exchangeId: string;
  apiKeys?: Omit<ApiKey, "storage">;
  oauth?: OAuth2Tokens;
  isProxied?: boolean;
};

export enum StorageType {
  BROWSER = "browser",
  PHONE = "phone",
  LEDGER = "ledger",
  SERVER = "server",
}

export type HubUserCredentials = {
  getAccessToken: () => Promise<string | null>;
  identityToken: string | null;
  identityProvider: AuthProvider;
  /** `null` for providers that cannot refresh (TON, local dev). */
  refreshIdentityToken: (() => Promise<string | null>) | null;
};

/** The `error` field of the API's 400 for a rejected identity token; the client refreshes the token on it. */
export const IDENTITY_TOKEN_INVALID_ERROR = "IdentityTokenInvalidError";
